export const variants = {
  default: {
    backgroundColor: "task-default-background-color",
    border: "1px solid rgba(233, 245, 254, 0.47)",
  },
  warning: {
    backgroundColor: "orange-lighten-96",
    border: "1px solid rgba(238, 149, 4, 0.16)",
  },
  error: {
    backgroundColor: "red-lighten-97",
    border: "1px solid rgba(227, 6, 19, 0.16)",
  },
  success: {
    backgroundColor: "task-success-background-color",
    border: "1px solid rgba(96, 152, 51, 0.32);",
  },
};

export const highlightVariants = {
  default: {
    backgroundColor: "grey-blue",
  },
  warning: {
    backgroundColor: "secondary-orange",
  },
  error: {
    backgroundColor: "primary-red",
  },
  success: {
    backgroundColor: "secondary-green",
  },
};

export const stepVariants = {
  completed: {
    backgroundColor: "grey-blue",
  },
  active: {
    backgroundColor: "transparent",
  },
  disabled: {
    backgroundColor: "transparent",
  },
};
